import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faHeadset, faPhone, faEnvelope } from '@fortawesome/free-solid-svg-icons';
import { SUPPORT_CONTACT } from './onboardingConfig';

const pillStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  gap: 8,
  padding: '10px 14px',
  borderRadius: 10,
  border: '1.5px solid #FF7700',
  color: '#c2410c',
  background: '#fff7ed',
  fontWeight: 600,
  fontSize: '0.9rem',
  textDecoration: 'none',
  whiteSpace: 'nowrap',
};

/** Support phone + email shown under the /listing wizard on every step. */
const ListingSupportBox = ({ style = {} }) => (
  <aside
    aria-label="Support contact"
    style={{
      background: '#fff',
      borderRadius: 16,
      padding: '16px 20px',
      border: '1px solid rgba(255,119,0,0.18)',
      boxShadow: '0 8px 24px rgba(255,119,0,0.08)',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 16,
      flexWrap: 'wrap',
      ...style,
    }}
  >
    <div style={{ display: 'flex', alignItems: 'center', gap: 12, minWidth: 0 }}>
      <div style={{ width: 40, height: 40, borderRadius: 10, background: '#fff7ed', display: 'flex', alignItems: 'center', justifyContent: 'center', color: '#FF7700', flexShrink: 0 }}>
        <FontAwesomeIcon icon={faHeadset} />
      </div>
      <div>
        <div style={{ fontWeight: 700, color: '#1e293b' }}>Need help listing your property?</div>
        <div style={{ fontSize: '0.85rem', color: '#64748b' }}>Our support team can walk you through any step.</div>
      </div>
    </div>
    <div style={{ display: 'flex', gap: 10, flexWrap: 'wrap' }}>
      <a href={SUPPORT_CONTACT.phoneHref} style={pillStyle}>
        <FontAwesomeIcon icon={faPhone} />
        {SUPPORT_CONTACT.phoneDisplay}
      </a>
      <a href={`mailto:${SUPPORT_CONTACT.email}`} style={pillStyle}>
        <FontAwesomeIcon icon={faEnvelope} />
        {SUPPORT_CONTACT.email}
      </a>
    </div>
  </aside>
);

export default ListingSupportBox;
